import { useState, useRef, useMemo } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import useOnClickOutside from '../hooks/useOnClickOutside';
import Picker from 'react-mobile-picker';
import { t } from '../utilities/translator';
import { isMobile } from '../utilities/helpers';
import Button from './button/Button';

interface AgeSelectProps {
  label: string;
  value: number;
  changeChildAge: (value: number) => void;
  infantsCount: number;
}

const AgeSelect = ({ label, value, changeChildAge, infantsCount }: AgeSelectProps) => {
  const mobileRef = useRef<HTMLDivElement>(null);
  const desktopRef = useRef<HTMLDivElement>(null);
  const [showOptions, setShowOptions] = useState(false);
  const [mobileTempValue, setMobileTempValue] = useState({ age: value.toString()});
  const selectedValue = value;

  const optArr = useMemo(() => {
    const optArr = [];
    for (
      let index = infantsCount === 0 || selectedValue < 2 ? 1 : 2;
      index <= 17;
      index++
    ) {
      optArr.push({ [`${index}`]: index, value: index });
    }
    return optArr;
  }, [infantsCount, selectedValue]);

  useOnClickOutside(mobileRef, () => showOptions && setShowOptions(false));
  useOnClickOutside(desktopRef, () => showOptions && !isMobile() && setShowOptions(false));

  const handleChildAge = (value: number) => {
    changeChildAge(value);
    setShowOptions(false);
  };

  const onMobileSaveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowOptions(false);
    changeChildAge(parseInt(mobileTempValue?.age, 10));
  }

  const selectList = (
    <ul className="custom-select__list">
      {optArr.map(({ value }) => (
        <li
          className={classNames('custom-select__item', {
            'custom-select__item--active': selectedValue === value,
          })}
          key={value}
          onClick={(e) => {
            e.stopPropagation();
            handleChildAge(value);
          }}
        >
          {t('mainFilter.childAge_plural', { count: value })}
          {selectedValue === value && <span className="checkmark" />}
        </li>
      ))}
    </ul>
  );

  return (
    <div
      className="custom-select text-start"
      onClick={() => {
        setShowOptions(true);
      }}
      ref={desktopRef}
    >
      {isMobile() ? (
        <div className="flex gap-5 items-center">
          <div className="text-[14px] text-tertiary font-medium">{label}</div>
          <div className="ms-auto text-[14px] text-primary font-semibold">{t('mainFilter.childAge_plural', { count: selectedValue })}</div>
          <i className="ri-arrow-down-s-line chevron"></i>
        </div>
        ) : (
          <>
            <p className="custom-select__title">{label}</p>
            <p className="custom-select__active-value">
              {t('mainFilter.childAge_plural', { count: selectedValue })}
            </p>
            <i className="ri-arrow-down-s-line chevron"></i>
          </>
        )}

      {showOptions ? (
        isMobile() ? (
          createPortal(
            <div className="picker-modal-container" ref={mobileRef}>
            <div className="picker-modal" style={{ display: showOptions ? 'block' : 'none'}}>
              <Button
                label={t('mainFilter.Save')}
                onClick={onMobileSaveClick}
              />
              <Picker value={mobileTempValue} onChange={setMobileTempValue}>
                <Picker.Column key="age" name="age">
                  {optArr.map(({ value }) => (
                    <Picker.Item key={value} value={value.toString()}>
                      {t('mainFilter.childAge_plural', { count: value })}
                    </Picker.Item>
                  ))}
                </Picker.Column>
              </Picker>
            </div>
          </div>, document.getElementById('modal-portal') as HTMLElement
          )
        ) : (
          selectList
        )
      ) : null}
    </div>
  );
};

export default AgeSelect;
